(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-results"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const tabTitles = document.querySelectorAll('.weekly-progress-section .tab-title');
  
  tabTitles.forEach(tab => {
    tab.addEventListener('click', function() {
      // Remove active class from all tabs and contents
      document.querySelectorAll('.weekly-progress-section .tab-title').forEach(t => t.classList.remove('active'));
      document.querySelectorAll('.weekly-progress-section .tab-content').forEach(c => c.classList.remove('active'));
      
      // Add active class to clicked tab
      this.classList.add('active');
      
      // Show corresponding content
      const tabId = this.getAttribute('data-tab');
      document.getElementById(tabId).classList.add('active');
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
